import { Input } from "@pankod/refine-antd";
import { FieldChangedCallback, IComponentField } from "./interfaces";

export function ComponentFormTextField({
    field,
    data,
    fieldChanged,
    location,
  }: {
    field: IComponentField;
    data: any;
    fieldChanged: FieldChangedCallback;
    location: string[];
  }) {
    return (
      <Input
        type={"text"}
        value={data ?? ''}
        onChange={(e) => fieldChanged([...location, field.name], e.target.value)}
      />
    );
  }